import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=70a6ff9c&scoped=true&"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBreadcrumbs.vue?vue&type=style&index=0&id=70a6ff9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6ff9c",
  null
  
)

export default component.exports